import PropTypes from "prop-types"

import styled from "styled-components"

const StyledBigCard = styled.div`
  background: var(--color-black);
  color: var(--color-v3-grey-20);
  padding: 64px 32px;
  border-radius: 16px;

  h2 {
    max-width: 520px;
    margin-inline: auto;
    color: var(--white);
  }

  h3 {
    font: var(--h5);
  }

  a {
    --color-background: var(--color-v3-green-20);
    --color-text: var(--color-v3-grey-90);
    --color-background-hover: var(--color-v3-green-30);
    display: inline-block;
    padding: 12px 25px;
    border-radius: var(--size-radius-md);
    font: var(--text-md);
    font-weight: 400;
    text-decoration: none;
    background: var(--color-background);
    color: var(--color-text);
    text-align: center;
    position: relative;
    text-align: center;
    -webkit-text-decoration: none;
    text-decoration: none;
    transition: all 0.15s ease-out;
  }

  & a:hover {
    /* --jxvquf7: var(--jxvquf5); */
    background: var(--color-background-hover);
    border-color: var(--color-background-hover);
    color: var(--color-text);
    border-radius: var(--size-radius-xl);
    cursor: pointer;
    text-decoration: none;
  }

  ${(props) => props.align === "center" && `text-align: center;`}

  @media (min-width: 992px) {
    padding: 64px 96px;
  }

  header {
    margin-bottom: 64px;
  }
`

const BigCard = (props) => {
  const { header, children, footer, theme, align, className } = props

  return (
    <StyledBigCard theme={theme} align={align} className={className}>
      {header && <header>{header}</header>}
      <main>{children}</main>
      {footer && <footer>{footer}</footer>}
    </StyledBigCard>
  )
}

BigCard.propTypes = {
  theme: PropTypes.oneOf(["dark", "outline", "red", "blue", "green", "blueDark", "magenta"]),
  align: PropTypes.oneOf(["left", "center"]),
}

BigCard.defaultProps = {
  theme: "dark",
  align: "center",
}

export default BigCard
